/**
 * When the admin SPA is opened under `/admin/...` without a matching
 * `PUBLIC_URL` basename, keep in-app links under the same prefix.
 */
export function withAdminPathPrefix(
  currentPathname: string,
  path: string
): string {
  if (!path.startsWith('/') || path.startsWith('/admin')) {
    return path;
  }
  if (currentPathname === '/admin' || currentPathname.startsWith('/admin/')) {
    return `/admin${path}`;
  }
  return path;
}
